import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  theme => ({
    root: {
      backgroundColor: 'lightblue',
    },
  }),
  { name: 'HelloWorld' }
)

export const HelloWorld = () => {
  const classes = useStyles()
  return <div className={classes.root}>Hello World OK</div>
}
